import "./EditSiteAlarmCentrals.html";
import "./EditSiteAlarmCentrals.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditSiteAlarmCentralsComponentController from "./EditSiteAlarmCentralsComponentController";

export default class EditSiteAlarmCentralsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditSiteAlarmCentralsComponentController;
        this.templateUrl =
            "/App/Components/Site/Overview/" +
            "AlarmCentralInformation/EditSiteAlarmCentrals/EditSiteAlarmCentrals.html";
    }
}

module("mmManagePortal").component("mmEditSiteAlarmCentrals", new EditSiteAlarmCentralsComponent());
